// extracted by mini-css-extract-plugin
export default {"content":"RequestGenerationContainer_content__gF-Xt"};